<template>
  <div id="linkRegister" class="bg-white linkRegister">
    <!-- Header -->
    <b-navbar v-if="!loading" type="dark" variant="secondary" class="p-2 sticky border-bottom-1" sticky>
      <span v-if="!loading" class="navbar-brand">
        <img :src="logo" />
      </span>
    </b-navbar>
    <!-- Page content -->
    <div class="container">
      <div v-if="!loading && !hashID && inviteToken && !errorChannelInfo" class="row">
        <div class="col-lg-12 col-md-12 cols-12">
          <div>
            <span class="text-custom w-100 pull-left pt-2">To join</span>
            <h2 class="text-center w-100">{{ clientName }}</h2>
            <span class="text-custom w-100 pt-2"
              >Please enter your details below. <br />
              Then click the "save only or save and install button"
            </span>
            <br />
            <small><i>Personal details entered here are kept securely and in strict confidence under the provisions of our Privacy Policy.</i></small>
          </div>
          <div class="w-100 mt-3">
            <form>
              <b-form-group role="group" class="mb-3 has-feedback">
                <input
                  v-model.trim="register.firstname"
                  v-validate="'required'"
                  type="text"
                  name="register.firstname"
                  data-vv-as="First Name"
                  data-vv-name="register.firstname"
                  data-vv-scope="register"
                  placeholder="First Name"
                  autocomplete="NoAutocomplete"
                  class="form-control no-instruction"
                  :class="{
                    input: true,
                    'is-invalid': errors.has('register.firstname'),
                    'has-invalid': errors.has('register.firstname'),
                  }" />
                <div class="invalid-feedback" :is-invalid="errors.has('register.firstname')">
                  {{ errors.first('register.firstname') }}
                </div>
              </b-form-group>

              <b-form-group role="group" class="mb-3 has-feedback">
                <input
                  v-model.trim="register.lastname"
                  v-validate="'required'"
                  type="text"
                  name="register.lastname"
                  data-vv-as="Last Name"
                  data-vv-name="register.lastname"
                  data-vv-scope="register"
                  placeholder="Last Name"
                  autocomplete="NoAutocomplete"
                  class="form-control no-instruction"
                  :class="{
                    input: true,
                    'is-invalid': errors.has('register.lastname'),
                    'has-invalid': errors.has('register.lastname'),
                  }" />
                <div class="invalid-feedback" :is-invalid="errors.has('register.lastname')">
                  {{ errors.first('register.lastname') }}
                </div>
              </b-form-group>

              <b-form-group v-if="!invitationFormSettings.onlyShowRequiredFields" role="group" class="mb-3 has-feedback">
                <input
                  key="register.email"
                  v-model.trim="register.email"
                  v-validate="'email'"
                  type="text"
                  name="register.email"
                  data-vv-as="email"
                  data-vv-name="register.email"
                  data-vv-scope="register"
                  placeholder="Email"
                  class="form-control no-instruction"
                  autocomplete="NoAutocomplete"
                  :class="{
                    input: true,
                    'is-invalid': errors.has('register.email'),
                    'has-invalid': errors.has('register.email'),
                  }" />
                <div class="invalid-feedback" :is-invalid="errors.has('register.email')">
                  {{ errors.first('register.email') }}
                </div>
              </b-form-group>
              <vue-country-code
                v-if="false"
                id="countryCode"
                v-model="register.country"
                v-validate="'required'"
                data-vv-as="Country Code"
                data-vv-name="register.country"
                data-vv-scope="register"
                enable-search-field
                @onSelect="getStates">
              </vue-country-code>
              <b-form-group role="group" class="has-feedback mb-3">
                <multiselect
                  v-model="register.countryCode"
                  name="register.countryCode"
                  label="text"
                  placeholder="Select Country Code"
                  track-by="value"
                  v-validate="'required'"
                  :options="countryCodes"
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                  open-direction="bottom"
                  :block-keys="['Tab', 'Enter']"
                  data-vv-scope="register"
                  data-vv-name="register.countryCode"
                  data-vv-as="country code"
                  :class="{
                    input: true,
                    'is-invalid': errors.has('register.countryCode'),
                    'has-invalid': errors.has('register.countryCode'),
                  }"
                  @select="getStates">
                  <template #singleLabel="props">
                    <div class="iti-flag pull-left mt-1 mr-2" :class="props.option.code"></div>
                    <span class="option-text pull-left mr-2">{{ props.option.text }}</span>
                    <span class="option-value">+{{ props.option.value }}</span>
                  </template>
                  <template #clear="props">
                    <div v-if="countryCodes" class="multiselect__clear" @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">No Country Codes</span>
                  <template #option="{ option }">
                    <span class="option__desc">
                      <div class="iti-flag pull-left mt-1 mr-3" :class="option.code"></div>
                      <span class="option-text mr-2">{{ option.text }}</span>
                      <span class="option-value">+{{ option.value }}</span>
                    </span>
                  </template>
                  <label v-show="register.countryCode" class="typo__label form__label">Please Select Country code</label>
                </multiselect>
                <div class="invalid-feedback" :is-invalid="errors.has('register.countryCode')">
                  {{ errors.first('register.countryCode') }}
                </div>
              </b-form-group>
              <b-form-group role="group" class="mb-3 has-feedback">
                <div class="phoneContainer">
                  <input id="left" v-model="dialCode" placeholder="+1" type="text" disabled name="register.countryCode" class="form-control no-instruction" />
                  <input
                    v-model.trim="register.phone"
                    v-validate="{
                      required: true,
                      phone: [dialCode],
                    }"
                    type="text"
                    name="register.phone"
                    data-vv-as="Cellphone Number"
                    data-vv-name="register.phone"
                    data-vv-scope="register"
                    placeholder="Cellphone Number"
                    class="form-control no-instruction"
                    autocomplete="NoAutocomplete"
                    :class="{
                      input: true,
                      'is-invalid': errors.has('register.phone'),
                      'has-invalid': errors.has('register.phone'),
                    }" />
                  <div class="invalid-feedback" :is-invalid="errors.has('register.phone')">
                    {{ errors.first('register.phone') }}
                  </div>
                </div>
              </b-form-group>

              <b-form-group v-if="!invitationFormSettings.onlyShowRequiredFields" role="group" class="mb-3 has-feedback">
                <input
                  v-model.trim="register.zipcode"
                  type="text"
                  name="register.zipcode"
                  data-vv-as="Zip Code"
                  data-vv-name="register.zipcode"
                  data-vv-scope="register"
                  placeholder="Enter Zip Code"
                  class="form-control no-instruction"
                  autocomplete="NoAutocomplete"
                  :class="{
                    input: true,
                    'is-invalid': errors.has('register.zipcode'),
                    'has-invalid': errors.has('register.zipcode'),
                  }" />
                <div class="invalid-feedback" :is-invalid="errors.has('register.zipcode')">
                  {{ errors.first('register.zipcode') }}
                </div>
              </b-form-group>

              <b-form-group v-if="!invitationFormSettings.onlyShowRequiredFields" role="group" class="mb-3 has-feedback">
                <b-form-select
                  v-model="register.state"
                  :options="states"
                  name="register.state"
                  placeholder="Select State"
                  data-vv-as="State"
                  data-vv-name="register.state"
                  data-vv-scope="register"
                  :disabled="states.length === 1"
                  class="form-control no-instruction"
                  :class="{
                    'is-invalid': errors.has('register.state'),
                    'has-invalid': errors.has('register.state'),
                  }">
                </b-form-select>

                <div class="invalid-feedback" :is-invalid="errors.has('register.state')">
                  {{ errors.first('register.state') }}
                </div>
              </b-form-group>

              <b-form-group v-if="secretCode && (secretCode !== '' || secretCode !== null)" role="group" class="mb-3 has-feedback">
                <input
                  v-model.trim="register.accessCode"
                  v-validate="{
                    required: secretCode && (secretCode !== '' || secretCode !== null),
                  }"
                  key="accessCode"
                  type="text"
                  name="register.accessCode"
                  data-vv-as="Secret Access Code"
                  data-vv-name="register.accessCode"
                  data-vv-scope="register"
                  :placeholder="`Secret Access Code (If you do not know your access code, please contact ${channelEmail} for assistance)`"
                  class="form-control no-instruction"
                  autocomplete="NoAutocomplete"
                  :class="{
                    input: true,
                    'is-invalid': errors.has('register.accessCode'),
                    'has-invalid': errors.has('register.accessCode'),
                  }" />
                <div class="invalid-feedback" :is-invalid="errors.has('register.accessCode')">
                  {{ errors.first('register.accessCode') }}
                </div>
              </b-form-group>

              <div style="display: flex; flex-direction: column" v-if="additionalPreApprovalField.field">
                <small class="pull-left w-100 text-left"> This field is required </small>
                <b-form-group role="group" class="mb-3 has-feedback">
                  <input
                    v-model.trim="additionalPreApprovalField.value"
                    v-validate="'required'"
                    type="text"
                    :placeholder="additionalPreApprovalField.field"
                    name="register.additionalPreApprovalField"
                    :data-vv-as="additionalPreApprovalField.field"
                    data-vv-name="register.additionalPreApprovalField"
                    data-vv-scope="register"
                    class="form-control no-instruction"
                    autocomplete="NoAutocomplete"
                    :class="{
                      input: true,
                      'is-invalid': errors.has('register.additionalPreApprovalField'),
                      'has-invalid': errors.has('register.additionalPreApprovalField'),
                    }" />
                  <div class="invalid-feedback" :is-invalid="errors.has('register.additionalPreApprovalField')">
                    {{ errors.first('register.additionalPreApprovalField') }}
                  </div>
                </b-form-group>
              </div>

              <div style="display: flex; flex-direction: column" v-if="invitationFormSettings.preApprovalFromUnionActive">
                <b-form-group role="group" class="mb-3 has-feedback">
                  <input
                    v-model.trim="memberId"
                    v-validate="'required'"
                    type="text"
                    placeholder="Member ID"
                    name="register.memberId"
                    data-vv-as="Member ID"
                    data-vv-name="register.memberId"
                    data-vv-scope="register"
                    class="form-control no-instruction"
                    autocomplete="NoAutocomplete"
                    :class="{
                      input: true,
                      'is-invalid': errors.has('register.memberId'),
                      'has-invalid': errors.has('register.memberId'),
                    }" />
                  <div class="invalid-feedback" :is-invalid="errors.has('register.memberId')">
                    {{ errors.first('register.memberId') }}
                  </div>
                </b-form-group>
              </div>

              <div v-if="customFieldSettings.length > 0" class="d-block text-center groupInfo">
                <div v-for="(custom, index) in customFieldSettings" :key="index">
                  <small class="pull-left w-100 text-left">
                    {{
                      custom.required && custom.single && custom.showInRegistration
                        ? 'This field is required and accepts single answer only'
                        : !custom.required && custom.showInRegistration && custom.single && !invitationFormSettings.onlyShowRequiredFields
                        ? 'This field accepts single answer only but not required'
                        : custom.required && custom.showInRegistration && !custom.single
                        ? 'This field is required and accepts multiple answer'
                        : !custom.required && !custom.single && custom.showInRegistration && !invitationFormSettings.onlyShowRequiredFields
                        ? 'This field accepts multiple answer but not required'
                        : ''
                    }}
                  </small>
                  <small class="text-danger w-100 pull-left text-left">{{
                    customFieldErrors.includes(custom.field) ? `The ${custom.field} field is required` : ''
                  }}</small>

                  <div v-if="custom.single && custom.showInRegistration && custom.required">
                    <b-form-radio-group>
                      <table class="table table-bordered table-striped groupTable">
                        <thead>
                          <tr>
                            <th>{{ custom.field }}</th>
                            <th>Check/Uncheck</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(modalFieldItem, modalFieldIndex) in custom.options" :key="modalFieldIndex">
                            <td>
                              <span class="text-sm">{{ capitalizeWords(modalFieldItem.text) }}</span>
                            </td>
                            <td>
                              <div class="custom-control custom-radio">
                                <b-form-radio
                                  :value="modalFieldItem.value"
                                  @change="selectCustomField(custom.field, modalFieldItem.value, custom.single, custom.required)"></b-form-radio>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-form-radio-group>
                  </div>

                  <div v-else-if="custom.single && !custom.required && custom.showInRegistration && !invitationFormSettings.onlyShowRequiredFields">
                    <b-form-checkbox-group>
                      <table class="table table-bordered table-striped groupTable">
                        <thead>
                          <tr>
                            <th>{{ capitalizeWords(custom.field) }}</th>
                            <th>Check/Uncheck</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(modalFieldItem, modalFieldIndex) in custom.options" :key="modalFieldIndex">
                            <td>
                              <span class="text-sm">{{ capitalizeWords(modalFieldItem.text) }}</span>
                            </td>
                            <td>
                              <div class="custom-control custom-checkbox">
                                <b-form-checkbox
                                  :value="modalFieldItem.value"
                                  @change="selectCustomField(custom.field, modalFieldItem.value, custom.single, custom.required)"></b-form-checkbox>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-form-checkbox-group>
                  </div>

                  <div v-else-if="!custom.single && !custom.required && custom.showInRegistration && !invitationFormSettings.onlyShowRequiredFields">
                    <b-form-checkbox-group>
                      <table class="table table-bordered table-striped groupTable">
                        <thead>
                          <tr>
                            <th>{{ capitalizeWords(custom.field) }}</th>
                            <th>Check/Uncheck</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(modalFieldItem, modalFieldIndex) in custom.options" :key="modalFieldIndex">
                            <td>
                              <span class="text-sm">{{ capitalizeWords(modalFieldItem.text) }}</span>
                            </td>
                            <td>
                              <div class="custom-control custom-checkbox">
                                <b-form-checkbox
                                  :value="modalFieldItem.value"
                                  @change="selectCustomField(custom.field, modalFieldItem.value, custom.single, custom.required)"></b-form-checkbox>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-form-checkbox-group>
                  </div>

                  <div v-else-if="!custom.single && custom.required && custom.showInRegistration">
                    <b-form-checkbox-group>
                      <table class="table table-bordered table-striped groupTable">
                        <thead>
                          <tr>
                            <th>{{ capitalizeWords(custom.field) }}</th>
                            <th>Check/Uncheck</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(modalFieldItem, modalFieldIndex) in custom.options" :key="modalFieldIndex">
                            <td>
                              <span class="text-sm">{{ capitalizeWords(modalFieldItem.text) }}</span>
                            </td>
                            <td>
                              <div class="custom-control custom-checkbox">
                                <b-form-checkbox
                                  :value="modalFieldItem.value"
                                  @change="selectCustomField(custom.field, modalFieldItem.value, custom.single, custom.required)"></b-form-checkbox>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-form-checkbox-group>
                  </div>
                </div>
              </div>
              <div v-if="groups.groups != null && groups.groupsFieldTitle != null && groups.groups.length > 0" class="d-block text-center groupInfo">
                <small v-if="groups.groups != null && groups.groupsFieldTitle != null && groups.groups.length > 0" class="pull-left w-100 text-left">
                  This field accepts {{ groups.groupSelectionSingleAnswer ? 'single answer' : 'multiple answers' }}
                  {{ groups.groupSelectionRequired ? 'and is required' : 'but not required' }}
                </small>
                <small class="text-danger w-100 pull-left text-left">{{ groups.groupError }}</small>
                <div>
                  <b-form-checkbox-group v-if="!groups.groupSelectionSingleAnswer">
                    <table class="table table-bordered table-striped groupTable">
                      <thead>
                        <tr>
                          <th>{{ groups.groupsFieldTitle }}</th>
                          <th>Check/Uncheck</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(group, index) in groups.groups" :key="index">
                          <td>
                            <span class="text-sm">{{ capitalizeWords(group.name) }}</span>
                          </td>
                          <td>
                            <div class="custom-control custom-checkbox">
                              <b-form-checkbox :value="group._id" @change="selectGroup(group._id)" :selected="group.selected"></b-form-checkbox>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-form-checkbox-group>
                  <b-form-radio-group v-else>
                    <table class="table table-bordered table-striped groupTable">
                      <thead>
                        <tr>
                          <th>{{ groups.groupsFieldTitle }}</th>
                          <th>Check/Uncheck</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(group, index) in groups.groups" :key="index">
                          <td>
                            <span class="text-sm">{{ capitalizeWords(group.name) }}</span>
                          </td>
                          <td>
                            <div class="custom-control custom-radio">
                              <b-form-radio :value="group._id" @change="selectGroup(group._id)"></b-form-radio>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-form-radio-group>
                </div>
              </div>
              <b-form-group role="group" class="mb-3 has-feedback"> </b-form-group>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-lg">
                  <button id="saveInstall" class="btn btn-success w-100 mb-2" type="button" @click="registerAccount('saveInstall')">
                    Save and Install
                    <span class="promise-btn__spinner-wrapper hidden"
                      ><span
                        data-v-cc3e8e04=""
                        class="spinner"
                        style="border-top-color: rgb(52, 152, 219); width: 18px; height: 18px; border-width: 4px; animation-duration: 1s"></span
                    ></span>
                  </button>
                  <div v-if="invitationFormSettings.includeSaveNotInstallOption">
                    <span class="text-custom w-100 pull-left p-2 text-center"
                      >Installing the App is not required but will provide many more features and a better experience overall.</span
                    >
                    <button id="saveOnly" class="btn btn-primary w-100" type="button" @click="registerAccount('saveOnly')">
                      Save Only <br />
                      Do Not Install the App
                      <span class="promise-btn__spinner-wrapper hidden"
                        ><span
                          data-v-cc3e8e04=""
                          class="spinner"
                          style="border-top-color: rgb(52, 152, 219); width: 18px; height: 18px; border-width: 4px; animation-duration: 1s"></span
                      ></span>
                    </button>
                    <span class="text-custom w-100 pull-left p-2 pb-3 text-center"
                      >By selecting 'Save Only' you are agreeing to accept text messages from {{ clientName }}</span
                    >
                  </div>
                </div>
              </div>
            </form>
            <b-modal ref="successModal" title="" centered scrollable :header-text-variant="'gray'">
              <div class="d-block text-center groupInfo text-drkr text-black">
                {{ successMessage }}
              </div>
              <template #modal-footer> </template>
            </b-modal>
            <b-modal ref="errorModal" title="" centered scrollable :header-text-variant="'gray'">
              <div class="d-block text-center groupInfo text-danger">
                {{ errorMessage }}
              </div>
              <template #modal-footer>
                <div class="row px-0 mx-0 w-100">
                  <div class="col-lg-12 col-md-12 col-12 no-gutters">
                    <button v-if="errorContinue" id="registerContinue" class="btn btn-success w-100 mb-2 pull-right" @click="registerContinue">
                      Okay
                      <span class="promise-btn__spinner-wrapper hidden"
                        ><span
                          data-v-cc3e8e04=""
                          class="spinner"
                          style="border-top-color: rgb(52, 152, 219); width: 18px; height: 18px; border-width: 4px; animation-duration: 1s"></span
                      ></span>
                    </button>
                    <button v-else class="btn btn-success w-100 mb-2 pull-right" @click="closeError">Okay</button>
                  </div>
                </div>
              </template>
            </b-modal>
          </div>
        </div>
      </div>

      <div v-if="!loading && hashID && !errorChannelInfo" class="row justify-content-center">
        <h2 class="mt-6 text-center" v-html="confirmMessage"></h2>
      </div>
      <div v-if="!loading && errorChannelInfo" class="row justify-content-center">
        <h2 class="mt-6 text-center text-danger" v-html="errorChannelInfoMessage"></h2>
      </div>
      <div v-if="loading" class="row justify-content-center">
        <b-row>
          <div class="col-lg-12 text-center">
            <pulse-loader :color="'#3867d6'"></pulse-loader>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VueCountryCode from 'vue-country-code-select';
import { countryCodes } from '@/utils/countryCodes';
import { usStates } from '@/utils/usStates';
import { Validator } from 'vee-validate';
import { phoneRule } from '@/utils/veeValidateRules';
import { NotificationTypes, wrapNotification } from '@/utils/notification';
import { getDeepLink } from '@/api/request/user';

Validator.extend('phone', phoneRule);

Vue.use(VueCountryCode);

const defaultRegister = {
  phone: null,
  firstname: null,
  lastname: null,
  email: null,
  phone: null,
  companyID: null,
  countryCode: { code: 'us', text: 'United States', value: 1 },
  country: null,
  state: null,
  zipcode: null,
  fundedProvider: null,
  accessCode: null,
};

export default {
  name: 'RegisterSMS',
  components: {},
  data() {
    return {
      additionalPreApprovalField: {
        field: null,
        value: null,
      },
      memberId: null,
      companyName: '',
      companyLogo: null,
      channelName: '',
      channelEmail: '',
      appLogo: null,
      companyCopyright: '',
      register: { ...defaultRegister },
      groups: {
        groups: null,
        groupsFieldTitle: null,
        groupSelectionRequired: false,
        groupSelectionSingleAnswer: false,
        groupError: '',
      },
      invitationFormSettings: {
        includeSaveNotInstallOption: false,
        onlyShowRequiredFields: false,
        defaultCountryCode: {
          code: 'us',
          text: 'United States',
          value: 1,
        },
      },
      companyInfo: null,
      userID: null,
      channelID: null,
      url: null,
      type: null,
      inviteToken: null,
      hashID: null,
      confirmMessage: '',
      statesAll: [],
      stateList: [],
      secretCode: null,
      dropdownClose: true,
      selectedCountry: '',
      token: null,
      successMessage: null,
      errorMessage: null,
      dialCode: null,
      customFieldList: {},
      customFieldSettings: [],
      currentSelectedField: {},
      currentSelectedFieldArray: {},
      customFieldErrors: [],
      errorChannelInfo: false,
      errorChannelInfoMessage: '',
      format4: '##-##',
      format5: '##-###',
      format6: '##-##-##',
      format7: '#-##-##-##',
      format8: '####-####',
      format9: '##-###-####',
      france: '#-##-##-##-##',
      formatDefault: '###-###-####',
      format11: '####-###-####',
      phoneFormat: '###-###-####',
      phoneMinLength: 12,
      phoneMaxLength: 12,
      errorContinue: false,
      errorContinueToken: null,
      oldFundedProvider: null,
      usStates: usStates,
      directDeepLink: undefined,
    };
  },
  computed: {
    logo: {
      get: function () {
        return this.appLogo || this.companyLogo;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    clientName: {
      get: function () {
        return this.channelName || this.companyName;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    loading() {
      return this.$store.state.user.confirmLinkRegisterLoading;
    },
    states: {
      get: function () {
        var data = [];
        if (this.stateList.length > 0) {
          this.stateList.map((state) => {
            data.push({
              value: `[${state.isoCode}] ${state.name}`,
              text: this.$options.filters.capitalizeWords(`[${state.isoCode}] ${state.name}`),
            });
          });
        }

        data.sort((a, b) => a.text.localeCompare(b.text));

        return [{ value: null, text: 'Select State', disabled: true }, ...data];
      },
      set: function (newValue) {
        return newValue;
      },
    },
    customFields: {
      get: function () {
        return this.customFieldList;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    countryCodes: {
      get: function () {
        return countryCodes;
      },
      set: function (newValue) {
        return newValue;
      },
    },
  },
  watch: {
    'register.countryCode': {
      immediate: true,
      handler: function (value) {
        if (value) {
          this.getStates();
        }
      },
    },
    'register.phone': {
      immediate: true,
      handler: function (value) {
        // console.log(value)
        if (value) {
        }
      },
    },
  },
  mounted() {
    const inviteToken = (this.inviteToken = this.$route.params.inviteToken);
    const hashID = (this.hashID = this.$route.params.hashID);

    if (hashID) {
      this.confirmRegisterLink(hashID);
    }

    if (inviteToken) {
      if (inviteToken.includes('download')) {
        this.errorChannelInfo = true;
        this.errorChannelInfoMessage = 'This link must be opened on a mobile device.';
      } else {
        this.getChannelInfo(inviteToken);
      }
    }
  },
  methods: {
    selectGroup(groupID) {
      this.groups.groupError = '';
      this.groups.groups.map((group) => {
        if (this.groups.groupSelectionSingleAnswer) {
          group.selected = false;
        }
        if (group._id === groupID) {
          group.selected = group.selected ? !group.selected : true;
        }
      });
    },
    getChannelInfo(inviteToken) {
      this.$store
        .dispatch('user/GET_CHANNEL_INFO', inviteToken)
        .then((resp) => {
          if (resp.data.success) {
            this.channelName = resp.data.clientName;
            this.appLogo = resp.data.appLogo;
            this.channelID = this.register.fundedProvider = resp.data.fundedProviderID;
            this.register.companyID = resp.data.companyID;
            this.statesAll = resp.data.states;
            this.secretCode = resp.data.accessCode || null;
            this.channelEmail = resp.data.email;
            this.invitationFormSettings = resp.data.invitationFormSettings;

            this.register.countryCode = this.invitationFormSettings.defaultCountryCode;

            this.groups = {
              groups: resp.data.groups ?? null,
              groupsFieldTitle: resp.data.groupsFieldTitle ?? null,
              groupSelectionRequired: resp.data.groupSelectionRequired ?? false,
              groupSelectionSingleAnswer: resp.data.groupSelectionSingleAnswer ?? false,
              groupError: '',
            };
            var customFields = [];

            this.directDeepLink = resp.data.deepLink;

            if (resp.data.additionalPreApprovalField) {
              this.additionalPreApprovalField = {
                field: resp.data.additionalPreApprovalField,
                value: null,
              };
            }

            resp.data.customFields.map((field) => {
              customFields.push({
                field: field.field,
                options: field.value.map((value) => {
                  return {
                    text: value,
                    value: value,
                  };
                }),
                required: field.required,
                single: field.single,
                showInRegistration: field.showInRegistration ? (this.invitationFormSettings.onlyShowRequiredFields ? field.required : true) : false,
              });
            });

            if (customFields.length > 0) {
              this.customFieldSettings = customFields;
              customFields.map((item) => {
                this.$set(this.customFieldList, item.field, []);
              });
            }
          } else {
            this.errorChannelInfo = true;
            this.errorChannelInfoMessage = 'Invitation link not valid. There is an error fetching channel configuration using the link.';
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    capitalizeWords(value) {
      return this.$options.filters.capitalizeWords(value);
    },
    hasProtocol(link) {
      const hasHttp = link.indexOf('http://') === 0 || link.indexOf('https://') === 0;
      return !hasHttp ? `http://${link}` : link;
    },
    confirmRegisterLink(hashID) {
      this.$store
        .dispatch('user/CONFIRM_REGISTER_LINK', hashID)
        .then((resp) => {
          if (resp.data.success) {
            this.channelName = resp.data.channel.clientName;
            this.appLogo = resp.data.channel.appLogo;
            this.confirmMessage = resp.data.message;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getStates() {
      Vue.nextTick(() => {
        if (this.register.countryCode) {
          var name = this.register.countryCode.text;
          var iso2 = this.register.countryCode.code;
          var dialCode = this.register.countryCode.value;

          iso2 = iso2 ? iso2.toUpperCase() : '';

          if (this.register.phone) {
            this.register.phone = '';
            this.errors.clear();
          }

          this.phoneFormat = this.getFormat(dialCode);

          if (name && iso2 && dialCode) {
            this.selectedCountry = `${name} (${iso2}) +${dialCode}`;
            this.register.country = iso2;
            this.dialCode = `+${dialCode}`;
          }

          if (this.statesAll.length > 0) {
            this.stateList = this.statesAll.filter((state) => state.countryCode === iso2);
          } else {
            this.stateList = this.usStates;
          }
        }
      });
    },
    getFormat(value) {
      const mask1 = '###-###-####';

      const numberLen = 15 - value.toString().length;
      const mask2 = '#'.repeat(numberLen);

      if (value === 1) {
        this.phoneMinLength = 10;
        this.phoneMaxLength = 14;
        return mask1;
      } else {
        this.phoneMinLength = 1;
        this.phoneMaxLength = numberLen;
        return mask2;
      }
    },
    toggleDropdown() {
      const dropdown = document.querySelector('.dropdown-list');

      if (dropdown.hasAttribute('style')) {
        dropdown.removeAttribute('style');
        this.dropdownClose = false;
      } else {
        dropdown.setAttribute('style', 'display: none !important');
        this.dropdownClose = true;
      }
    },
    registerAccount(type = 'saveInstall') {
      var promiseBtn;

      if (type == 'saveInstall') {
        promiseBtn = document.getElementById('saveInstall');
      } else {
        promiseBtn = document.getElementById('saveOnly');
      }

      const promiseBtnInner = promiseBtn.querySelector('.promise-btn__spinner-wrapper');

      promiseBtnInner.classList.remove('hidden');
      promiseBtn.setAttribute('disabled', 'disabled');
      const linkRegister = document.getElementById('linkRegister');
      linkRegister.classList.add('non-clickable');

      var required = [];
      if (this.customFieldSettings.length > 0) {
        const requiredFields = this.customFieldSettings.filter((item) => item.required && item.showInRegistration).map((item) => item.field);
        if (Object.keys(this.customFields).length > 0) {
          for (var i in this.customFields) {
            if (requiredFields.includes(i)) {
              if (this.customFieldSettings.filter((item) => item.field === i)[0].single) {
                if (this.customFields[i].length === 0) {
                  required.push(i);
                }
              } else {
                if (this.customFields[i].length === 0 && this.customFields[i].showInProfile === false) {
                  required.push(i);
                }
              }
            }
          }

          if (required.length > 0) {
            this.customFieldErrors = required;
          }
        }
      }

      if (this.groups.groupSelectionRequired && this.groups.groups != null && this.groups.groups.length > 0) {
        if (this.groups.groups.filter((group) => group.selected).length === 0) {
          wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(`Please select at least one group`));
          promiseBtnInner.classList.add('hidden');
          promiseBtn.removeAttribute('disabled', 'disabled');
          linkRegister.classList.remove('non-clickable');
          this.groups.groupError = 'Please select at least one group';
          return false;
        }
      }
      // if single answer is required
      if (this.groups.groupSelectionSingleAnswer && this.groups.groups != null && this.groups.groups.length > 0) {
        if (this.groups.groups.filter((group) => group.selected).length > 1) {
          wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(`Please select only one group`));
          promiseBtnInner.classList.add('hidden');
          promiseBtn.removeAttribute('disabled', 'disabled');
          linkRegister.classList.remove('non-clickable');
          this.groups.groupError = 'Please select only one group';
          return false;
        }
      }

      return this.$validator.validateAll('register').then((isValid) => {
        if (isValid) {
          if (required.length > 0) {
            this.customFieldErrors = required;
            wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(`Please provide all required fields`));

            promiseBtnInner.classList.add('hidden');
            promiseBtn.removeAttribute('disabled', 'disabled');
            linkRegister.classList.remove('non-clickable');

            return false;
          } else {
            var customFields = [];
            this.customFieldErrors = [];

            if (Object.keys(this.customFields).length > 0) {
              for (var i in this.customFields) {
                customFields.push({
                  field: i,
                  value: this.customFields[i],
                });
              }
              this.register.customFields = customFields;
            }

            this.register.newPhone = `${this.register.phone}`;

            if (!this.register.phone.includes('+')) {
              if (this.dialCode === '+1') {
                // remove white space
                this.register.phone = this.register.phone.replace(/\s/g, '');
                this.register.phone = this.register.phone.replace(/[^0-9]/g, '');

                if (this.register.phone.length === 10) {
                  this.register.phone = this.register.phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
                  this.register.newPhone = `${this.dialCode} ${this.register.phone}`;
                } else {
                  this.$validator.errors.add({
                    field: 'register.phone',
                    msg: 'Please enter a valid phone number',
                    scope: 'register',
                    id: 'register.phone',
                  });
                  promiseBtnInner.classList.add('hidden');
                  promiseBtn.removeAttribute('disabled', 'disabled');
                  linkRegister.classList.remove('non-clickable');
                  return false;
                }
              } else {
                // only allow numbers in phone number
                this.register.phone = this.register.phone.replace(/[^0-9]/g, '');
                this.register.newPhone = `${this.dialCode} ${this.register.phone}`;
              }
            }
            this.register.type = type === 'saveInstall' ? 'mobile' : 'web';
            if (this.groups != null && this.groups.groups != null && this.groups.groups.length > 0) {
              this.register.groups = this.groups.groups.filter((group) => group.selected).map((group) => group._id);
            }
            if (this.additionalPreApprovalField.field) {
              this.register.additionalPreApprovalField = {
                field: this.additionalPreApprovalField.field,
                value: this.additionalPreApprovalField.value,
              };
            }
            if (this.invitationFormSettings.preApprovalFromUnionActive && this.memberId) {
              this.register.memberId = this.memberId;
            }

            this.$store
              .dispatch('user/REGISTER_USER_BY_LINK', this.register)
              .then((resp) => {
                console.log('user/REGISTER_USER_BY_LINK', resp);
                if (resp.data.success) {
                  this.token = resp.data.token;

                  this.register.phone = null;
                  this.register.firstname = null;
                  this.register.lastname = null;
                  this.register.email = null;
                  this.register.phocompanyIDne = null;
                  this.register.zipcode = null;
                  this.register.accessCode = null;
                  this.register.newPhone = null;
                  this.additionalPreApprovalField.value = null;
                  this.memberId = null;

                  this.$validator.reset();
                  this.errors.clear();

                  var data = {
                    token: resp.data.token,
                    type: type === 'saveInstall' ? 'mobile' : 'web',
                  };

                  if (data.type === 'mobile' && this.directDeepLink) {
                    getDeepLink(data.token)
                      .then((resp) => {
                        if (resp.data.error) {
                          wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(resp.data.message));
                          promiseBtnInner.classList.add('hidden');
                          promiseBtn.removeAttribute('disabled', 'disabled');
                          linkRegister.classList.remove('non-clickable');
                          this.$refs['errorModal'].hide();
                          return;
                        }
                        if (resp.data.success) {
                          const deepLink = resp.data.deepLink;
                          const primaryChannel = resp.data.primaryChannel;
                          this.showDeepLinkModal(data, resp.data.deepLink, primaryChannel);
                        }
                      })
                      .catch((err) => {
                        console.error(err);
                        promiseBtnInner.classList.add('hidden');
                        promiseBtn.removeAttribute('disabled', 'disabled');
                        linkRegister.classList.remove('non-clickable');
                      });
                  } else {
                    this.$store
                      .dispatch('user/SEND_SMS_REGISTER', data)
                      .then((resp) => {
                        if (resp.data.success) {
                          this.successMessage = resp.data.message;
                          this.$refs['successModal'].show();
                          this.$validator.reset();
                          this.errors.clear();

                          promiseBtnInner.classList.add('hidden');
                          promiseBtn.removeAttribute('disabled', 'disabled');
                          linkRegister.classList.remove('non-clickable');
                        }
                      })
                      .catch((err) => {
                        console.error(err);
                        promiseBtnInner.classList.add('hidden');
                        promiseBtn.removeAttribute('disabled', 'disabled');
                        linkRegister.classList.remove('non-clickable');
                      });
                  }
                } else {
                  if (
                    resp.data.error === 'error_invalid_access_code' ||
                    resp.data.error === 'error_social_title_mismatch' ||
                    resp.data.error === 'pre_approval_denied'
                  ) {
                    wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(resp.data.message));

                    promiseBtnInner.classList.add('hidden');
                    promiseBtn.removeAttribute('disabled', 'disabled');
                    linkRegister.classList.remove('non-clickable');
                    this.$refs['errorModal'].hide();
                  } else {
                    if (resp.data.error === 'error_phone_conflict_to_other_account_error52') {
                      this.errorContinue = true;
                      this.errorContinueToken = resp.data.token;
                      this.oldFundedProvider = resp.data.oldFundedProvider;
                    }

                    this.$refs['errorModal'].show();
                    this.errorMessage = resp.data.message;

                    promiseBtnInner.classList.add('hidden');
                    promiseBtn.removeAttribute('disabled', 'disabled');
                    linkRegister.classList.remove('non-clickable');
                  }
                }
              })
              .catch((err) => {
                console.error(err);
                err.then((error) => {
                  wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(error.errMessage));
                  promiseBtnInner.classList.add('hidden');
                  promiseBtn.removeAttribute('disabled', 'disabled');
                  linkRegister.classList.remove('non-clickable');
                });
              });
          }
        } else {
          wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords('Please provide all required fields'));

          promiseBtnInner.classList.add('hidden');
          promiseBtn.removeAttribute('disabled', 'disabled');
          linkRegister.classList.remove('non-clickable');
        }
      });
    },
    checkCountOfItems(customFieldsSelected) {
      /*if (customFieldsSelected.length === 1) {
          if (customFieldsSelected[0] !== value) {
            return false
          } else {
            return true
          }
        }*/
    },
    selectCustomField(field, value, isSingle, isRequired) {
      if (Object.keys(this.customFieldList).length > 0) {
        if (isSingle) {
          this.customFields[field] = [];
          this.customFields[field].push(value);
        } else {
          let index = this.customFields[field].indexOf(value);
          if (index > -1) {
            this.customFields[field].splice(index, 1);
          } else {
            this.customFields[field].push(value);
          }
        }
        // this.$set(this.customFieldList, field, value)
      }
    },
    closeError() {
      this.$refs['errorModal'].hide();
    },

    showDeepLinkModal(smsData, deepLink, primaryChannel) {
      if (!primaryChannel || this.channelID !== primaryChannel) {
        console.log('Primary channel not found', primaryChannel);
        console.log('Channel ID does not match primary channel', this.channelID);

        wrapNotification(this.$notify, NotificationTypes.Error, 'Deep Link Error');
        promiseBtnInner.classList.add('hidden');
        promiseBtn.removeAttribute('disabled', 'disabled');
        linkRegister.classList.remove('non-clickable');
        this.$validator.reset();
        this.errors.clear();
        this.$refs['errorModal'].hide();
        return;
      }

      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        this.$store
          .dispatch('user/SEND_SMS_REGISTER', smsData)
          .then((resp) => {
            if (resp.data.success) {
              this.successMessage = resp.data.message;
              this.$refs['successModal'].show();
              this.$validator.reset();
              this.errors.clear();

              promiseBtnInner.classList.add('hidden');
              promiseBtn.removeAttribute('disabled', 'disabled');
              linkRegister.classList.remove('non-clickable');
            }
          })
          .catch((err) => {
            console.error(err);
            promiseBtnInner.classList.add('hidden');
            promiseBtn.removeAttribute('disabled', 'disabled');
            linkRegister.classList.remove('non-clickable');
          });
      } else {
        window.location.href = deepLink;
        promiseBtnInner.classList.add('hidden');
        promiseBtn.removeAttribute('disabled', 'disabled');
        linkRegister.classList.remove('non-clickable');
      }
    },
    registerContinue() {
      var promiseBtn = '';
      if (this.register.type === 'mobile') {
        promiseBtn = document.getElementById('saveInstall');
      } else {
        promiseBtn = document.getElementById('saveOnly');
      }
      const promiseBtnInner = promiseBtn.querySelector('.promise-btn__spinner-wrapper');

      promiseBtnInner.classList.remove('hidden');
      promiseBtn.setAttribute('disabled', 'disabled');
      const linkRegister = document.getElementById('linkRegister');
      linkRegister.classList.add('non-clickable');

      var customFields = [];
      this.customFieldErrors = [];

      if (Object.keys(this.customFields).length > 0) {
        for (var i in this.customFields) {
          customFields.push({
            field: i,
            value: this.customFields[i],
          });
        }
        this.register.customFields = customFields;
      }

      this.register.token = this.errorContinueToken;
      this.register.oldFundedProvider = this.oldFundedProvider;
      var data = {
        token: this.register.token,
        type: this.register.type,
      };

      if (data.type === 'mobile' && this.directDeepLink) {
        getDeepLink(data.token)
          .then((resp) => {
            if (resp.data.error === 'error_social_title_mismatch') {
              wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(resp.data.message));
              promiseBtnInner.classList.add('hidden');
              promiseBtn.removeAttribute('disabled', 'disabled');
              linkRegister.classList.remove('non-clickable');
              this.$refs['errorModal'].hide();
              this.register = { ...defaultRegister };
              this.errors.clear();
              this.$validator.reset();
              return;
            }
            const deepLink = resp.data.deepLink;
            const primaryChannel = resp.data.primaryChannel;
            this.showDeepLinkModal(data, deepLink, primaryChannel);
          })
          .catch((err) => {
            console.error(err);
            promiseBtnInner.classList.add('hidden');
            promiseBtn.removeAttribute('disabled', 'disabled');
            linkRegister.classList.remove('non-clickable');
          });
      } else {
        this.$store
          .dispatch('user/SEND_SMS_REGISTER', data)
          .then((resp) => {
            if (resp.data.success) {
              this.successMessage = resp.data.message;
              this.$refs['successModal'].show();
              this.$validator.reset();
              this.errors.clear();

              promiseBtnInner.classList.add('hidden');
              promiseBtn.removeAttribute('disabled', 'disabled');
              linkRegister.classList.remove('non-clickable');
            }
          })
          .catch((err) => {
            console.error(err);
            promiseBtnInner.classList.add('hidden');
            promiseBtn.removeAttribute('disabled', 'disabled');
            linkRegister.classList.remove('non-clickable');
          });
      }
    },
  },
};
</script>
<style lang="scss">
.is-invalid {
  display: block;
}
.linkRegister {
  min-height: 812px;
  .text-custom {
    font-size: 13px;
    line-height: 13px;
    font-weight: bold;
  }
  .navbar-header {
    float: left;
    padding: 15px;
    text-align: center;
    width: 100%;
  }
  span.navbar-brand {
    float: none;
    margin: 0 auto;
    text-align: center;
    span {
      color: #000;
    }
    img {
      height: 60px;
    }
  }
  .custom-select {
    option {
      width: 100%;
    }
  }
  .multiselect__tags {
    display: block;
    width: 100%;
    font-weight: 400;
    line-height: 1.5;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #adb5bd;
    border-radius: 0.25rem;
    font-size: 0.875rem;
    transition: all 0.15s ease-in-out;
    height: calc(1.5em + 1.25rem + 5px);
    color: #525f7f !important;
  }
  .multiselect__single {
    font-size: 0.875rem;
    color: #525f7f !important;
    margin-bottom: 0;
    padding-bottom: 0;
    padding-top: 4px;
  }

  .multiselect.input.is-invalid.has-invalid .multiselect__tags {
    border: 1px solid #f4516c !important;
  }

  .multiselect.input.is-invalid.has-invalid ~ .invalid-feedback {
    display: block;
  }
}

.message-content {
  h2 {
    padding-left: 15px;
    padding-right: 15px;
  }
  a {
    color: #5867dd;
  }
  .image {
    img {
      width: 100% !important;
    }
  }
}
.player-wrapper {
  margin: 0 auto;
}
.border-bottom-1 {
  border-bottom: 1px solid #adb5bd;
}

.countryCode {
  display: block;
  width: 100%;
  padding: 0.625rem 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #adb5bd;
  border-radius: 0.25rem;

  font-size: 0.875rem;
  transition: all 0.15s ease-in-out;
  height: calc(1.5em + 1.25rem + 5px);
  color: #525f7f !important;
  .dropdown-arrow {
    transform: scaleY(0.5);
    display: inline-block;
    color: #666;
    height: 78px;
    width: 40px;
    position: absolute;
    right: 0;
    top: -14px;
    padding: 25px 14px;
  }
}
#countryCode {
  display: block;
  width: 100%;
  font-weight: 400;
  line-height: 1.5;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #adb5bd;
  border-radius: 0.25rem;

  font-size: 0.875rem;
  transition: all 0.15s ease-in-out;
  height: calc(1.5em + 1.25rem + 5px);
  color: #525f7f !important;
  .dropdown {
    padding: 0.625rem 0.75rem;
    border-radius: 0.25rem;
    background-color: transparent !important;
    .current {
      width: 100%;
      display: inline-block;
      div.iti-flag {
        float: left;
        display: inline-block;
        margin-top: 5px;
      }
      .dropdown-arrow {
        float: right;
        transform: scaleY(0.5);
        display: inline-block;
        color: #666;
      }
    }
    ul.dropdown-list {
      width: 345px !important;
    }
  }
}
.countryText {
  margin-left: 10px;
  padding: 4px 0;
  font-size: 0.875rem;
}

.rc-anchor-normal {
  height: 74px;
  width: 99% !important;
}
.search-field {
  input {
    height: calc(1.5em + 1rem) !important;
  }
}
.phoneContainer {
  display: grid;
  grid-template-columns: 8vh 1fr;

  #left {
    text-align: end;
  }

  .invalid-feedback {
    grid-column: 1 / span2;
  }
}
</style>
